export const environment = {
  production: true,
  apiUrl: 'https://referrerportalapi-qa-stack2.azurewebsites.net/api/',
  fileApiUrl: 'https://cm-file-api-d5dfgafneseudqgv.z01.azurefd.net/api/',
};
